<template>
  <div class="main-container">
    
    <breadcrumb :list="breadcrumbList" />
   

    <div class="margintop-32" />
      <tl-header type="h1">Add Exiting Employee</tl-header>
        <div class="row">
          <div class="col-3 padding-l-n">
            <tl-select
              label="Month"
              labelText="name"
              v-model="month"
              :options="monthsList"
              @change="(val)=>month = val"
            />
          </div>
              
        </div>
          <div class="centerclass" v-if="!employeeData.length">
        <div class="img"><img src="@/assets/empty.svg" class="resize"></div>
         <div class="text"><span class="bold-text">No investment plans to show yet!</span>
          <div class="Click-on-Add-New-t"> <span >click on 'Add New' to create first investment plan</span> </div>
            <div>
              <button class="add-btn-small" @click="createForm()" ><img src="@/assets/group-5.svg" class="resize"><span class="add-new">Add New</span></button>
            </div>
        </div>
      </div>
    
        <div class="add-btn-small">
        <button class="addnewbtn" v-if="employeeData.length>1"  @click="createForm()">
          <img src="@/assets/group-5.svg" />
          <span class="add-new">Add New</span>
        </button>
      </div>

  </div>
  
</template>


<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  props: {},
  components: {},
  data() {
    return {
      employeeData : [],
      breadcrumbList: [
        {
          name: "Organisation",
          url: `/dashboard/${this.$route.params.entity_index}/`
        },
        {
          name: "exits",
          url: ``
        }
      ],
      month: "",
      monthsList: [
        { name: "January", value: "jan" },
        { name: "February", value: "feb" },
        { name: "March", value: "mar" },
        { name: "April", value: "apr" },
        { name: "May", value: "may" },
        { name: "June", value: "jun" },
        { name: "July", value: "jul" },
        { name: "August", value: "aug" },
        { name: "September", value: "sep" },
        { name: "October", value: "oct" },
        { name: "November", value: "nov" },
        { name: "December", value: "dec" }
      ],
      navList: [
        {
          name: "Add Resignee",
          url: ``
        },
        {
          name: "FnF ",
          url: ``
        },
      ],
      
    };
  },
  activated(){
    let d = new Date();
    this.month = this.monthsList[d.getMonth()];
        this.employeeData = [];
    this.fetchemp();    
  },
  mounted(){
    let d = new Date();
    this.month = this.monthsList[d.getMonth()];
        this.employeeData = [];
    this.fetchemp();

  },

  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    }
  },
  methods: {

        /* to map all actions from the stores */
    ...mapActions({
      act_fetch: "dashboard/organisation/exits/fetchExits"

    }),
     navigateToExits(url){
         this.$router.push({
        path:url
          });
      },
      /* function to navigate to add employee/s */
    createForm() {
      this.$router.push({
        
        path: `/dashboard/${this.$route.params.entity_index}/exits/addexitsemployee`
      });
    },
      /** Navigation on 'cancel' button click */
    addResignee() {
      try {
        this.$router.push({
          path: `/utilities/fnf/${
            this.$route.params.entity_index
          }/fnf`
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    async fetchemp() {
      try {
        let res = await this.act_fetch({ le_id: this.le_id, page: this.page });
      //console.log("testing.......",res)
        if (res.data.status) {
          let empList = [];
          this.totalEmployees = res.data.payload.totalEmpCount;
          res.data.payload.data.forEach(element => {
            empList.push({
              id: element.id,
              name:
                element.first_name +
                " " +
                (element.last_name ? element.last_name : ""),
              code: element.code,
              
            });
          });
          this.employeeData.push(...empList);
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /* function to get Employees on scroll */
    onScroll() {
      let bottomOfWindow =
        this.$refs.table_div.scrollHeight - this.$refs.table_div.scrollTop <=
        this.$refs.table_div.offsetHeight;
      if (bottomOfWindow && this.employeeData.length < this.totalEmployees) {
        this.page += 1;
        this.fetchemp();
      }
    },

  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/margins.scss"; //margins
@import "@/scss/_variables.scss";
.table-div {
  min-height: 350px;
  // max-height: 500px;
  margin-bottom: 175px;
  overflow: auto;
}

.mask {
  width: 258.5px;
  height: 144px;
  border-radius: 8px;
  border: solid 1px #e9e9e9;
  background-color: #ffffff;
  padding: 20px 24px;
  margin: 20px 20px 20px 0px;
}
.centerclass{
  margin: 100px 100px 200px 500px ;
}
.resize{
  margin-left: 100px;
}
.bold-text{
    width: 345px;
  height: 24px;
  font-family: Montserrat;
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #444444;
  margin-top: 40px;
}
.add-new{
    width: 68px;
  height: 18px;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #37c6c0;
}
.Click-on-Add-New-t {
  width: 403px;
  height: 19px;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #444444;
  margin-left: -30px;
  margin-top: 10px;
}
.oval {
  background-color: #ffa000;
  width: 55px;
  height: 55px;
  border-radius: 41px;
}

.add-btn-small {
  margin-top: 30px;
  height: auto;
  padding: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .text {
    color: #858585;
    font-size: 14px;
  }
}

.employee-info {
  height: 150px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  padding: 20px 15px 20px 25px;
  position: relative;
  &:nth-child(n) {
    margin-right: 20px;
  }
  .btn-primary-small {
    background-color: white;
    color: $color-primary;
    border-radius: 4px;
    border: 1px solid $color-primary;
    height: 25px;
    padding: 0px 20px;
    font-size: $font-size-small;
    width: auto;
  }

  .header-text {
    font-size: 24px;
    font-weight: bold;
    color: $color-secondary;
  }
  .sub-text {
    font-size: 20px;
    color: $color-primary;
    margin-top: 20px;
  }
  .btn-upload {
    position: absolute;
    bottom: 20px;
    right: 15px;
  }
}
.noData {
  text-align: center;
  padding: 10% 0 10% 0;
  span {
    color: #858585;
    font-size: 18px;
  }
}
.action-container {
  margin-left: auto;
  display: flex;
  justify-content: flex-end;
}
.noData {
  text-align: center;
  padding: 10% 0 10% 0;
}
.noData span {
  font-size: 18px;
  color: #858585;
}
.lineheight{
  height: 1px;
}
</style>
